import React from 'react'
import PropTypes from 'prop-types'
import * as ui from 'Helper/visualHelpers'
import DivButton from '../DivButton/DivButton.jsx'

// NOTIFY KAYLA IF YOU MAKE ANY CHANGES TO THIS FILE

class ModifyButtons extends React.PureComponent {
  static doSuccessAnimation = ref => {
    if (ref) {
      ui.toggleClass(ref, ['animate__animated', 'animate__flip'], 1000)
    }
  }
  static doFailAnimation = ref => {
    if (ref) {
      ui.toggleClass(ref, ['animate__animated', 'animate__shake'], 1000)
    }
  }
  static doClickAnimation = ref => {
    if (ref) {
      ui.toggleClass(ref, ['animate__animated', 'animate__pulse'], 500)
    }
  }
  render() {
    const {
      deleteHandler,
      updateHandler,
      saveHandler,
      saveNewHandler,
      cancelHandler,
      showDelete = false,
      showUpdate = false,
      showSave = false,
      showSaveNew = false,
      showCancel = false,
      deleteText = 'Delete',
      updateText = 'Update',
      cancelText = 'Cancel',
      saveText = 'Save',
      saveNewText = 'New'
    } = this.props

    const deleteBtn = showDelete
      ? (
      <ControlButton
        type="delete"
        text={deleteText}
        handler={deleteHandler}
        getButtonRef={this.props.getDeleteButtonRef}
        disabled={this.props.deleteDisabled}
        data-toggle={this.props.deleteDataToggle || null}
        data-title={this.props.deleteDataTitle || null}
      />
        )
      : null
    const update = showUpdate
      ? (
      <ControlButton
        type="update"
        text={updateText}
        handler={updateHandler}
        getButtonRef={this.props.getUpdateButtonRef}
        disabled={this.props.updateDisabled}
        data-toggle={this.props.updateDataToggle || null}
        data-title={this.props.updateDataTitle || null}
      />
        )
      : null
    const cancel = showCancel
      ? (
      <ControlButton
        type="cancel"
        text={cancelText}
        handler={cancelHandler}
        getButtonRef={this.props.getCancelButtonRef}
        disabled={this.props.cancelDisabled}
        data-toggle={this.props.cancelDataToggle || null}
        data-title={this.props.cancelDataTitle || null}
      />
        )
      : null
    const save = showSave
      ? (
      <ControlButton
        type="save"
        text={saveText}
        handler={saveHandler}
        getButtonRef={this.props.getSaveButtonRef}
        disabled={this.props.saveDisabled}
        data-toggle={this.props.saveDataToggle || null}
        data-title={this.props.saveDataTitle || null}
      />
        )
      : null
    const saveNew = showSaveNew
      ? (
      <ControlButton
        type="new"
        text={saveNewText}
        handler={saveNewHandler}
        getButtonRef={this.props.getSaveNewButtonRef}
        disabled={this.props.saveNewDisabled}
        data-toggle={this.props.saveNewDataToggle || null}
        data-title={this.props.saveNewDataTitle || null}
      />
        )
      : null

    return (
      <div className="modify-buttons-group">
        {cancel}
        {deleteBtn}
        {update}
        {saveNew}
        {save}
      </div>
    )
  }
}

ModifyButtons.propTypes = {
  // Should delete button be displayed
  showDeleted: PropTypes.bool,
  // Callback to attach to delete button
  deleteHandler: PropTypes.func,
  // Should cancel button be displayed
  showCancel: PropTypes.bool,
  // Callback to attach to cancel button
  cancelHandler: PropTypes.func,
  // Should update button be displayed
  showUpdate: PropTypes.bool,
  // Callback to attach to update button
  updateHandler: PropTypes.func,
  // Should save button be displayed
  showSave: PropTypes.bool,
  // Callback to attach to save button
  saveHandler: PropTypes.func,
  // Should "save new" button be displayed
  showSaveNew: PropTypes.bool,
  // Callback to attach to save new button.
  saveNewHandler: PropTypes.func,
  // functions for parent to fetch refs of the buttons for annimation callbacks
  getSaveButtonRef: PropTypes.func,
  getSaveNewButtonRef: PropTypes.func,
  getCancelButtonRef: PropTypes.func,
  getUpdateButtonRef: PropTypes.func,
  getDeleteButtonRef: PropTypes.func,
  deleteText: PropTypes.string,
  cancelText: PropTypes.string,
  saveText: PropTypes.string,
  saveNewText: PropTypes.string,
  updateText: PropTypes.string,
  // disable buttons
  saveNewDisabled: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  cancelDisabled: PropTypes.bool,
  updateDisabled: PropTypes.bool,
  deleteDisabled: PropTypes.bool,
  // data-toggle
  deleteDataToggle: PropTypes.string,
  updateDataToggle: PropTypes.string,
  cancelDataToggle: PropTypes.string,
  saveDataToggle: PropTypes.string,
  saveNewDataToggle: PropTypes.string,
  // tooltips per button
  deleteDataTitle: PropTypes.string,
  updateDataTitle: PropTypes.string,
  cancelDataTitle: PropTypes.string,
  saveDataTitle: PropTypes.string,
  saveNewDataTitle: PropTypes.string
  // non props exactly but the following functions can be called statically from a parent
  // to perform consistent animates on the buttons by passing back in the ref from
  // the getXXXButtonRef functions.
  // ModifyButtons.doSuccessAnimation(ref)
  // ModifyButtons.doFailAnimation(ref)
  // ModifyButtons.doClickAnimation(ref)
}

export default ModifyButtons

const ControlButton = props => {
  let type
  // using this so I can apply css to certain buttons
  const specialClassName = props.text.replace(/\s/g, '-')
  switch (props.type.toLowerCase()) {
    case 'cancel':
      type = 'btn-default'
      break
    case 'new':
      type = 'btn-success'
      break
    case 'delete':
      type = 'btn-danger'
      break
    case 'update':
      type = 'btn-warning'
      break
    default:
      type = 'btn-primary'
  }
  return (
    <DivButton
      ref={props.getButtonRef || null}
      type="button"
      className={`btn ${type} ${specialClassName}`}
      aria-label={`${props.text} button`}
      onClick={props.handler}
      disabled={props.disabled}
      data-toggle={props['data-toggle'] || null}
      data-title={props['data-title'] || null}
      data-placement="top"
      data-container="body"
      data-trigger="hover"
    >
      {props.text}
    </DivButton>
  )
}
